import ProxyServerConnector from '~/services/connectors/ProxyServerConnector';

class DesignsService extends ProxyServerConnector {
    gateway: ProxyServerConnector;

    constructor(path = '/creatives') {
        super(path);
        this.gateway = new ProxyServerConnector(path, GATEWAY_PREFIX);
    }

    createBlankDesign(data, collectionId) {
        let path = `/blank`;

        if (collectionId) {
            path += `?collectionId=${collectionId}`;
        }

        return this.gateway.put<{ id: number; name: string }>(path, data);
    }

    createFromXML(data, collectionId) {
        return this.gateway.post(`/from-xml${collectionId ? `?collectionId=${collectionId}` : ''}`, data);
    }

    duplicateCreatives(ids, collectionId) {
        return this.gateway.put('/duplicate', { ids, collectionId });
    }

    createVideoCreative(data) {
        return this.gateway.put<{ id: number }>('/convert', data);
    }
}

export default new DesignsService();
